/*
 * File: UpdateCourseSelfScheduleCriteria.ts
 * Author: Austin Robinson
 * Date Created: 10/8/2023
 * Copyright (c) DrivingDoc 2023
 */
import { createMutation } from 'react-query-kit';

import { PostGreSQLInterval, privateApi } from 'api';

export type UpdateCourseSelfScheduleCriteriaParams = {
  courseId: string;
  policy: {
    min_time_from_first_to_last: PostGreSQLInterval | null;
    max_time_from_first_to_last: PostGreSQLInterval | null;
    min_time_between_periods: PostGreSQLInterval | null;
    max_bookings_in_advance: number | null;
    max_bookings_in_interval: number | null;
    max_bookings_interval: PostGreSQLInterval | null;
    require_permit: boolean | null;
    first_period_max_balance: number | null;
    last_period_max_balance: number | null;
    other_max_balance: number | null;
  };
};

export type UpdateCourseSelfScheduleCriteriaResult = boolean;

async function updateCourseSelfScheduleCriteria(
  params: UpdateCourseSelfScheduleCriteriaParams,
): Promise<UpdateCourseSelfScheduleCriteriaResult> {
  // make api call
  const result = await privateApi.put(
    `${import.meta.env.VITE_API_BASE_URL}/courses/${params.courseId}/selfScheduleCriteria`,
    params.policy,
  );

  // return the data object
  return result.data;
}

const useUpdateCourseSelfScheduleCriteria = createMutation({
  mutationFn: async (variables: UpdateCourseSelfScheduleCriteriaParams) => updateCourseSelfScheduleCriteria(variables),
});

export { updateCourseSelfScheduleCriteria, useUpdateCourseSelfScheduleCriteria };
